import { Denom } from '../../Denom';
import { JSONSerializable } from '../../../util/json';
import { Dec, Numeric } from '../../numeric';
import { AccAddress, ValAddress } from '../../strings';
import { MsgExchangeRatePrevote } from './MsgExchangeRatePrevote';
import SHA256 from 'crypto-js/sha256';

export function voteHash(
  exchangeRate: string,
  denom: Denom,
  salt: string,
  validator: ValAddress
): string {
  const payload = `${salt}:${exchangeRate}:${denom}:${validator}`;
  return SHA256(payload).toString().substring(0, 40);
}

export class MsgExchangeRateVote extends JSONSerializable<
  MsgExchangeRateVote.Data
> {
  public exchange_rate: Dec;

  constructor(
    exchange_rate: Numeric.Input,
    public denom: Denom,
    public salt: string,
    public feeder: AccAddress,
    public validator: ValAddress
  ) {
    super();
    this.exchange_rate = new Dec(exchange_rate);
  }

  public static fromData(data: MsgExchangeRateVote.Data): MsgExchangeRateVote {
    const {
      value: { exchange_rate, salt, denom, feeder, validator },
    } = data;
    return new MsgExchangeRateVote(
      exchange_rate,
      denom,
      salt,
      feeder,
      validator
    );
  }

  public toData(): MsgExchangeRateVote.Data {
    const { exchange_rate, salt, denom, feeder, validator } = this;
    return {
      type: 'oracle/MsgExchangeRateVote',
      value: {
        exchange_rate: exchange_rate.toString(),
        denom,
        salt,
        feeder,
        validator,
      },
    };
  }

  public getVoteHash(): string {
    return voteHash(
      this.exchange_rate.toString(),
      this.denom,
      this.salt,
      this.validator
    );
  }

  public getPrevote(): MsgExchangeRatePrevote {
    return new MsgExchangeRatePrevote(
      this.getVoteHash(),
      this.denom,
      this.feeder,
      this.validator
    );
  }
}

export namespace MsgExchangeRateVote {
  export interface Data {
    type: 'oracle/MsgExchangeRateVote';
    value: {
      exchange_rate: string;
      denom: Denom;
      salt: string;
      feeder: AccAddress;
      validator: ValAddress;
    };
  }
}
